export default __webpack_public_path__ + "static/poem-ro-a89df7eb34ea6fdccf970fb40efd140d.png";